module.exports = __webpack_public_path__ + "static/media/avatar.f657fc60.svg";